<template>
  <div>
    {{ recordTypeTitle }}
  </div>
</template>

<script setup>
import {computed, getCurrentInstance, onBeforeMount} from "vue"
import {useStore} from "vuex"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()
let i18n = null

onBeforeMount(() => {
  i18n = (getCurrentInstance())?.ctx?.$i18n
})

const recordTypes = computed(() => store.state.auth.record_types || [])

const recordTypeTitle = computed(() => {
  const recordType = recordTypes.value.find(rt => rt.id === props.object?.record_type_id)
  return recordType?.title || i18n.t(props.object.record_type)
})
</script>
